import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

import { useState } from "react";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";

import { EffectCards } from "swiper/modules";
import w1 from "../assets/w1.jpg";
import w2 from "../assets/lawn.jpeg";
import w3 from "../assets/tree.jpg";
import w4 from "../assets/irrigation.jpg";
import w5 from "../assets/w5.jpg";
import w6 from "../assets/w6.jpg";
import w7 from "../assets/w7.jpg";
import w8 from "../assets/w8.jpg";

import logo from "../assets/logo.png";
import { Breadcrumbs, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeIcon from "@mui/icons-material/Home";
const gallery1 = [w2, w3, w4, w1];
const gallery2 = [w5, w6, w7, w8];
function AboutPage() {
  return (
    <div>
      <Navbar />
      <SecondHero title={"About"} breadcrumb="About" img={logo} />
      <About />
      <Footer />
    </div>
  );
}

export default AboutPage;

const About = () => {
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (window.innerWidth <= 1024) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, [window.innerWidth]);
  const [currentGallery, setCurrentGallery] = useState(gallery1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentGallery((prevGallery) =>
        prevGallery === gallery1 ? gallery2 : gallery1
      );
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <section className="flex flex-col md:flex-row gap-8  max-screen py-10 lg:py-20">
      <div className="flex-1 flex flex-col gap-6">
        <h2 className="text-4xl font-bold text-neutral-1">
          Get to Know A&L Landscaping
        </h2>
        <div className="flex flex-col gap-2 text-neutral-3">
          <p className="">
            Since our establishment, A&L Landscaping has been a trailblazer in
            the landscaping and lawn care industry. Our journey has been marked
            by a relentless pursuit of excellence, pushing boundaries, and
            redefining outdoor aesthetics. As stewards of the natural world, we
            take great pride in nurturing landscapes and lawns that flourish
            under our care.
          </p>
          <p>
            {" "}
            At the heart of A&L Landscaping's philosophy is the belief in the
            power of imagination. Our team of dedicated artisans and experts
            channel their creativity into crafting living works of art. From
            intricately designed garden retreats to vibrant, lush lawns, we
            transform your dreams into breathtaking realities. With each
            project, we infuse passion and innovation, ensuring that every space
            we touch exudes its own unique personality.
          </p>
          <p>
            A flourishing garden is more than just greenery; it's a sanctuary
            for the soul. A&L Landscaping is committed to delivering outdoor
            environments that elevate your daily life. Our meticulous attention
            to detail, commitment to quality, and devotion to sustainable
            practices set us apart as leaders in our field. We believe that
            outdoor spaces should not only inspire but also rejuvenate, and
            that's precisely what we create – outdoor sanctuaries that beckon
            you to unwind and reconnect with nature.
          </p>
          <p>
            At A&L Landscaping, your vision takes center stage. Our
            collaboration is a journey of exploration, where your aspirations
            blend seamlessly with our expertise. We invite you to dream big,
            think bold, and embark on a voyage of co-creation. Together, we will
            design and shape landscapes that are an extension of your identity,
            ensuring that every corner reflects your style and sensibilities.
          </p>
          <p>
            From the initial spark of inspiration to the final brushstroke of
            care, A&L Landscaping is dedicated to delivering an experience that
            brings joy and tranquility to your life. As you explore our range of
            services, you'll find that our passion extends beyond landscaping
            and lawn care – it's a commitment to enriching your connection with
            nature. With A&L Landscaping by your side, you're not just inviting
            greenery into your surroundings; you're inviting a sense of wonder,
            an oasis of calm, and a slice of nature's marvels.
          </p>
          <p>
            Welcome to a world where landscapes are not just cultivated; they're
            curated with love and expertise. Welcome to A&L Landscaping, a realm
            where your outdoor dreams come to life. Join us on a journey of
            imagination, transformation, and exploration, as we weave the
            tapestry of nature into the fabric of your everyday existence.
            Together, let's create a legacy of beauty, serenity, and inspiration
            that stands the test of time.
          </p>
        </div>
      </div>
      <div className="flex-1 overflow-hidden relative">
        <div className="bg-white absolute -top-2 -right-2 px-3 py-2 rounded-xl z-20">
          <CircleIndicator />
        </div>
        {mobile ? (
          <div className="card-gallery">
            <Swiper
              effect={"cards"}
              grabCursor={true}
              modules={[EffectCards]}
              className="">
              {currentGallery.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <img
                      src={item}
                      alt="gallery"
                      className="aspect-square object-cover"
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        ) : (
          <div className="grid-gallery h-[600px]">
            {currentGallery.map((item, index) => {
              return (
                <div
                  className={`div${index + 1} overflow-hidden rounded-xl`}
                  key={index}>
                  <img
                    src={item}
                    alt="gallery"
                    className="transition-all  duration-500 hover:!scale-105 "
                    data-aos={index % 2 === 0 ? "flip-right" : "flip-left"}
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000"
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};
const CircleIndicator = () => {
  useEffect(() => {
    const circle = document.querySelector(".circle");
    const interval = 5000;

    function startCarouselIndicator() {
      circle.classList.remove("active");
      void circle.offsetWidth;
      circle.classList.add("active");
    }

    setInterval(startCarouselIndicator, interval);
  }, []);
  return (
    <div className="circle active">
      <svg viewBox="0 0 52 52" className="circle-back">
        <circle cx="26" cy="26" r="25" />
      </svg>
      <svg viewBox="0 0 52 52" className="circle-front">
        <circle cx="26" cy="26" r="25" />
      </svg>
    </div>
  );
};

const SecondHero = ({ page, title, mb, breadcrumb, img }) => {
  return (
    <div
      className={`grid bg-gradient-to-tr from-primary to-secondary/80  place-content-center px-4 min-h-[70vh] md:min-h-[70vh] lg:min-h-[60vh] mb-${mb} secondHero relative z-10`}>
      <img
        src={logo}
        alt="logo"
        width={512}
        className="abs-c  transition-all px-4"
      />
      <div className="absolute w-full h-full bg-black/20 z-0 "></div>
      <div
        className="text-center text-white flex-c flex-col relative z-10"
        data-aos="fade-up"
        data-aos-delay={500}
        data-aos-once={true}>
        <Stack spacing={2}>
          <Breadcrumbs
            className="text-white text-3xl"
            separator={
              <NavigateNextIcon fontSize="small" sx={{ color: "white" }} />
            }
            aria-label="breadcrumb">
            {breadcrumbs(breadcrumb)}
          </Breadcrumbs>
        </Stack>
        <h2 className="text-5xl sm:text-6xl font-bold my-4">{title}</h2>
      </div>
    </div>
  );
};

const breadcrumbs = (serviceType) => [
  <Link
    underline="hover"
    key="1"
    className="text-white hover:text-primary flex items-center"
    to="/">
    <HomeIcon />
    Home
  </Link>,
  <Typography className="text-white" key="2">
    Services
  </Typography>,
  <Typography
    className="text-white bg-secondary/70 px-2 py-1 rounded-full"
    key="3">
    {serviceType}
  </Typography>,
];
